import React, { FunctionComponent, memo, useRef, useEffect } from "react";
import { Flex, Box, useColorModeValue } from "@chakra-ui/react";
import { select, easeCubicIn } from "d3";


interface IProps{
  value: number;
  offline: boolean;
}


const SourceProgress: FunctionComponent<IProps> = memo(function SourceProgress({
  value,
  offline,
}) {
  const positiveRef = useRef<HTMLDivElement>(null);
  const negativeRef = useRef<HTMLDivElement>(null);
  const offlineColor = useColorModeValue("white", "black");
  const onlineColor = useColorModeValue("black", "white");

  useEffect(() => {
    const positiveSel = select(positiveRef.current);
    const negativeSel = select(negativeRef.current);

    positiveSel
      .transition()
        .duration(1500)
        .ease(easeCubicIn)
        .style("width", `${Math.max(0, Math.max(0, value))}%`)
        ;

    negativeSel
      .transition()
        .duration(1500)
        .ease(easeCubicIn)
        .style("width", `${Math.max(0, -Math.min(0, value))}%`)
        ;
  }, [positiveRef, value]);

  return <>
    <Flex
      h={"2px"}
      mt={1}
      mb={4}
      flexDirection="row"
      justifyContent="space-between"
      bg={offline ? offlineColor : onlineColor}
    >
      <Box
        ref={positiveRef}
        bg={offline ? offlineColor : onlineColor}
        h={"14px"}
        position="relative"
        top={"-6px"}
      />
      <Box
        ref={negativeRef}
        bg={offline ? offlineColor : onlineColor}
        h={"14px"}
        position="relative"
        top={"-6px"}
      />
    </Flex>
  </>
});

export default SourceProgress;
